module.exports = __webpack_public_path__ + "83cb77e627b11798d1adf6886b63ceea.png";